import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { routeTree } from "./routeTree.gen";
import "./index.css";
import { ErrorBoundary } from "@app/error-boundary";
import { Providers } from "@app/providers";

const router = createRouter({
	routeTree,
	defaultPreload: "intent",
	defaultStaleTime: 5000,
	scrollRestoration: true,
});

declare module "@tanstack/react-router" {
	interface StaticDataRouteOption {
		breadcrumbTitle?: string;
		breadcrumbId?: string;
	}
	interface Register {
		breadcrumbTitle: string;
		breadcrumbId: string;
	}
}

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
	<StrictMode>
		<ErrorBoundary>
			<Providers>
				<RouterProvider router={router} />
			</Providers>
		</ErrorBoundary>
	</StrictMode>
);
